import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { NavLink } from 'react-router-dom';

const NavItem = ({ title, linkTo, colorInvert = false }) => {
  const linkColor = colorInvert ? 'common.white' : 'text.primary';

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      sx={{ cursor: 'pointer' }}
    >
      <NavLink 
        to={linkTo}
        style={({ isActive }) => {
          return {
            fontWeight: isActive ? "700" : "400",
          };
        }}  
      >
        <Typography
          fontSize={'1.4rem'}
          color={linkColor}
          fontWeight={'inherit'}
        >

        {title}
        </Typography>
      </NavLink>
    </Box>
  )
};

NavItem.propTypes = {
  title: PropTypes.string.isRequired,
  linkTo: PropTypes.string.isRequired,
};

export default NavItem;
